import { PageHero } from "@/components/PageHero";
import { Link } from "react-router-dom";

const CHECKLIST = [
  "Submit move-in form & ID at the security gate (signed by owner if rented).",
  "Register your vehicle(s) at the management office for parking stickers.",
  "Activate the MyGate app — entry, deliveries and helpdesk live here.",
  "Pay your one-time clubhouse activation and meet the facility manager.",
  "Pick up your welcome kit: amenity guide, contacts and discount coupons.",
  "Schedule water, gas and electricity meter readings within 48 hours.",
  "Subscribe to the residents' WhatsApp announcement channel.",
  "Familiarise yourself with waste segregation — green, blue & red bins.",
];

const NewResidents = () => (
  <div data-testid="new-residents-page">
    <PageHero
      overline="New Residents"
      title={
        <>
          Welcome home.
          <br />
          <span className="italic text-brand-gold">Let&apos;s get you settled.</span>
        </>
      }
      lead="A quick onboarding to help you find your feet at Exente — everything from utilities to your first community potluck."
      image="https://images.unsplash.com/photo-1721322800607-8c38375eef04?auto=format&fit=crop&w=1600&q=80"
    />

    <section className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-display text-3xl md:text-4xl text-brand-forest mb-12">
          Your first-week checklist
        </h2>
        <ol className="space-y-4">
          {CHECKLIST.map((item, i) => (
            <li
              key={i}
              data-testid={`checklist-${i}`}
              className="flex items-start gap-5 p-6 rounded-xl border border-brand-sage bg-brand-ivory hover:border-brand-gold transition-colors"
            >
              <span className="font-display text-2xl text-brand-gold w-10 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-brand-mute leading-relaxed pt-1">{item}</span>
            </li>
          ))}
        </ol>

        <div className="mt-16 p-10 rounded-2xl bg-brand-forest text-brand-ivory flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="font-display text-3xl">Need a hand?</div>
            <p className="text-brand-ivory/75 mt-2">
              The management team is at the clubhouse, Mon — Sat, 9:30 AM — 6:00 PM.
            </p>
          </div>
          <Link
            to="/contact"
            data-testid="new-residents-contact-cta"
            className="inline-flex items-center px-6 py-3 rounded-full bg-brand-gold text-brand-forest font-medium hover:bg-brand-ivory transition-colors"
          >
            Contact management
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default NewResidents;
